"use client";
import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

export default function BlankSection() {
    const marqueeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!marqueeRef.current) return;

        const marquee = marqueeRef.current;
        const totalWidth = marquee.scrollWidth / 2;

        const animation = gsap.to(marquee, {
            x: -totalWidth,
            duration: 30,
            ease: "none",
            repeat: -1,
        });

        return () => {
            animation.kill();
        };
    }, []);

    return (
        <section className="relative z-10 w-full flex flex-col items-start justify-start bg-black overflow-hidden mt-0 md:-mt-48 pt-12 md:pt-32 pb-10 md:pb-24 px-6 md:px-24" data-theme="dark">
            {/* White Text Content */}
            <div className="relative z-10 w-full max-w-4xl pt-0">
                <h2 className="text-2xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.3] md:leading-[1.2] tracking-tight" style={{ fontFamily: "var(--font-clash), 'Clash Display', sans-serif" }}>
                    Build predictable demand with no unnecessary spend, accelerating business growth through performance-driven digital marketing systems
                </h2>
            </div>

            {/* Marquee Text */}
            <div className="relative z-0 mt-10 md:mt-16 w-full pointer-events-none select-none">
                <div
                    ref={marqueeRef}
                    className="flex whitespace-nowrap will-change-transform"
                >
                    {[1, 2].map((_, idx) => (
                        <div key={idx} className="flex items-center">
                            <span className="text-[12vw] font-bold tracking-tighter uppercase px-8 md:px-12" style={{ color: '#CEFF1A' }}>
                                Strategy. Precision. Growth.
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
